import React from "react";
import GitHubCalendar from "react-github-calendar";

export const GitStats = () => {
  // Theme styling for the GitHub Calendar to match Alok's Cyberpunk neon green theme
  const customTheme = {
    level0: '#111827',
    level1: '#003b25',
    level2: '#007044',
    level3: '#00a862',
    level4: '#00ff9f',
  };

  return (
    <div
      id="gitstats"
      className="w-full bg-cyber-black text-gray-300 py-20 px-6 flex items-center justify-center border-t border-cyber-green/10"
    >
      <div className="max-w-5xl w-full space-y-12">
        <div className="text-center md:text-left">
          <h2 className="text-3xl font-mono font-bold text-cyber-green inline border-b-2 border-cyber-green pb-2">
            GIT_INTEGRATION // CONTRIBUTIONS
          </h2>
          <p className="mt-4 font-mono text-sm text-cyber-gray-400">
            Realtime activity tracking and statistics from Alok&apos;s Github console.
          </p>
        </div>

        {/* Grid Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 py-4">
          
          {/* Calendar Card - spans full width on md */}
          <div className="md:col-span-2 border border-cyber-blue/20 bg-cyber-darker/60 p-6 rounded-2xl flex flex-col items-center hover:border-cyber-blue transition duration-300 shadow-glow-blue-sm overflow-hidden">
            <h3 className="font-mono text-sm text-cyber-blue font-bold mb-6 self-start">
              // ACTIVE_CONTRIBUTION_GRID
            </h3>
            <div className="w-full overflow-x-auto py-2 flex justify-center react-activity-calendar">
              <GitHubCalendar
                username="aloki9singh"
                theme={customTheme}
                blockSize={12}
                blockMargin={4}
              />
            </div>
            <p className="font-mono text-xs text-cyber-gray-500 mt-4">
              [SYSTEM_LOG] CONTRIB_GRID_RENDERED_SUCCESSFULLY
            </p>
          </div>

          {/* GitHub Streak Card */}
          <div className="border border-cyber-gray-800 bg-cyber-darker/40 p-6 rounded-2xl flex flex-col items-center hover:border-cyber-green transition duration-300">
            <h3 className="font-mono text-xs text-cyber-green font-bold mb-4 self-start">
              // STREAK_MODULE
            </h3>
            <div className="w-full flex justify-center">
              <img
                id="github-streak-stats"
                src="https://github-readme-streak-stats.herokuapp.com?user=aloki9singh&theme=cyberpunk&hide_border=true&date_format=j%20M%5B%20Y%5D&mode=weekly"
                alt="Alok Singh Github Streak"
                className="max-w-full h-auto rounded-lg border border-cyber-gray-800"
              />
            </div>
          </div>

          {/* Github Stats Card */}
          <div className="border border-cyber-gray-800 bg-cyber-darker/40 p-6 rounded-2xl flex flex-col items-center hover:border-cyber-blue transition duration-300">
            <h3 className="font-mono text-xs text-cyber-blue font-bold mb-4 self-start">
              // STATS_MODULE
            </h3>
            <div className="w-full flex justify-center">
              <img 
               id="github-stats-card"
               src="https://github-stats-extended.vercel.app/api?username=aloki9singh&show_icons=true&theme=dark&hide_border=true" 
               alt="Alok Singh Github Stats"
               className="w-full max-w-md mx-auto rounded-lg shadow-lg hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
